import { useRouter } from "next/router";
import AnimationHeading from "src/components/AnimationsTags/AnimationHeading/AnimationHeading";
import AnimationParagraph from "src/components/AnimationsTags/AnimationParagraph/AnimationParagraph";
import Image from "next/image";
import parse from 'html-react-parser';
import Overlay from "src/components/Overlay/Overlay";
import OurTeamImage1 from "public/assets/sections/about_company/our_team/IMG_9295.JPG";
import OurTeamImage2 from "public/assets/sections/about_company/our_team/IMG_9288.JPG";
import OurTeamImage3 from "public/assets/sections/about_company/our_team/IMG_9289.JPG";
import OurTeamImage4 from "public/assets/sections/about_company/our_team/IMG_9290.JPG";
import OurTeamImage5 from "public/assets/sections/about_company/our_team/IMG_9291.JPG";
import OurTeamImage6 from "public/assets/sections/about_company/our_team/IMG_9292.JPG";
import OurTeamImage7 from "public/assets/sections/about_company/our_team/IMG_9293.JPG";
import OurTeamImage8 from "public/assets/sections/about_company/our_team/IMG_9294.JPG";
import OurTeamLocales from "./locales/data"

const OurTeam = () => {
  const { locale } = useRouter();

  return (
    <section id="our-team" className="px-4 py-12 xl:py-20">
      <div className="container mx-auto flex flex-col">
        <div className="w-full">
          <AnimationHeading
            title={OurTeamLocales[locale].title}
            size="text-2xl xl:text-4xl"
            additionalStyle="lg:text-center uppercase tracking-wider text-center"
            margin="pb-4 xl:pb-10 xl:text-center"
          />
          <AnimationParagraph>
            {parse(OurTeamLocales[locale].content)}
          </AnimationParagraph>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 lg:gap-8 px-0 lg:px-20 mt-12">
          <div className="col-span-6 md:col-span-3 relative w-full rounded-3xl overflow-hidden h-72 md:h-96 contrast-[0.9]">
            <Image src={OurTeamImage7} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-3 relative w-full rounded-3xl overflow-hidden h-72 md:h-96 contrast-[0.9]">
            <Image src={OurTeamImage8} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 relative w-full rounded-3xl overflow-hidden h-72 md:h-[500px] contrast-[0.9]">
            <Image src={OurTeamImage1} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-2 relative w-full rounded-3xl overflow-hidden h-72 contrast-[0.9]">
            <Image src={OurTeamImage2} alt="" layout="fill" objectFit="cover" objectPosition="top" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-2 relative w-full rounded-3xl overflow-hidden h-72 contrast-[0.9]">
            <Image src={OurTeamImage3} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-2 relative w-full rounded-3xl overflow-hidden h-72 contrast-[0.9]">
            <Image src={OurTeamImage4} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-3 relative w-full rounded-3xl overflow-hidden h-72 md:h-96 contrast-[0.9]">
            <Image src={OurTeamImage5} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
          <div className="col-span-6 md:col-span-3 relative w-full rounded-3xl overflow-hidden h-72 md:h-96 contrast-[0.9]">
            <Image src={OurTeamImage6} alt="" layout="fill" objectFit="cover" />
            <Overlay opacity="bg-opacity-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;